import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  standalone: false
})
export class PaginatorComponent {

  @Input() currentPage!: number;
  @Input() totalPages!: number;

  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();

}
